import React from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdEdit } from "react-icons/md";

const MaintenanceDetails = ({ setViewMaintenanceDetail, SelectedData, setEditMaintenanceDetails }) => {
  const onClose = () => {
    setViewMaintenanceDetail(false);
  };
  const onEditMaintenanceDetails = () => {
    setEditMaintenanceDetails(true);
    setViewMaintenanceDetail(false);
  };

  return (
    <Container>
      <div className="flex items-center justify-between bg-[#0078BD] py-4 px-4">
        <Title className="text-white">{"Maintenance Details"}</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </div>
      <div className="px-4 h-full flex flex-col justify-between py-4 relative">
        <Wrapper>
          {/* <BtnWrapper>
            <SectionTitle>
              Expiry Detail
            </SectionTitle>
            <SubmitBtn type="submit" onClick={onEditMaintenanceDetails}>
              <MdEdit size={12} /> Edit
            </SubmitBtn>
          </BtnWrapper> */}
          {/* <SectionTitle>Expiry Detail</SectionTitle> */}
          {/* <BtnWrapper>
            <SectionTitle>
              Expiry & Maintenance Detail
            </SectionTitle>
            <SubmitBtn type="submit" onClick={onEditMaintenanceDetails}>
              <MdEdit size={12} className="text-gray-300"/>
              Edit
            </SubmitBtn>
          </BtnWrapper> */}
          <SectionTitle>
            Expiry & Maintenance Detail
          </SectionTitle>
          <Section>
            <Row>
              <Label>Expiry Date</Label>
              <Value>{SelectedData?.expiryDate || "25-02-2027"}</Value>
            </Row>

            {/* </Section>
          <SectionTitle>Maintenance Details</SectionTitle>
          <Section> */}
            <Row>
              <Label>Last Maintenance Date</Label>
              <Value>{SelectedData?.maintenanceDate || "20-01-2024"}</Value>
            </Row>
            <Row>
              <Label>Next Maintenance Date</Label>
              <Value>{SelectedData?.mobile || "20-02-2023"}</Value>
            </Row>
            <Row>
              <Label>Maintenance Notes</Label>
              <Value>{SelectedData?.notes || "Any Notes "}</Value>
            </Row>

            {/* </Section>
          <SectionTitle>Vendor Detail</SectionTitle>
          <Section> */}
            <Row>
              <Label>Assigned Vendor </Label>
              <Value>{SelectedData?.assignVendor || "Vendor Name"}</Value>
            </Row>

          </Section>
          <BtnWrapper>

            <SubmitBtn type="submit" onClick={onEditMaintenanceDetails}>
              {/* <MdEdit size={12} className="text-gray-300"/> */}
              Edit
            </SubmitBtn>
          </BtnWrapper>

        </Wrapper>
      </div>
    </Container>
  );
};

const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Section = tw.div``;
const SectionTitle = tw.h2`text-lg font-semibold text-gray-700`;
const Row = tw.div`flex justify-between py-2 md:p-2`;
const Label = tw.label`text-sm text-gray-500 font-normal`;
const Value = tw.span`text-gray-800 font-medium`;
const SubmitBtn = tw.button`
  flex text-md w-auto md:text-sm text-blue-600 mt-auto hover:text-blue-600 underline px-2 py-1
`;
const BtnWrapper = tw.div`w-full flex items-center justify-end `;
export default MaintenanceDetails;